import { render, staticRenderFns } from "./MinimalNavigationPanel.vue?vue&type=template&id=4f67aa95&scoped=true&"
import script from "./MinimalNavigationPanel.vue?vue&type=script&lang=js&"
export * from "./MinimalNavigationPanel.vue?vue&type=script&lang=js&"
import style0 from "./MinimalNavigationPanel.vue?vue&type=style&index=0&id=4f67aa95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f67aa95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f67aa95')) {
      api.createRecord('4f67aa95', component.options)
    } else {
      api.reload('4f67aa95', component.options)
    }
    module.hot.accept("./MinimalNavigationPanel.vue?vue&type=template&id=4f67aa95&scoped=true&", function () {
      api.rerender('4f67aa95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/components/MinimalNavigationPanel.vue"
export default component.exports